import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import {
  ConsoleUsagePage,
  type ConsoleUsageWindow,
  consoleUsageBreakdownQueryOptions,
  consoleUsageQueryOptions,
  isConsoleUsageWindow,
} from "@/features/console";

interface ConsoleUsageSearch {
  /** 7/30/90-day consumption window — deep-linkable (?window=7d). */
  window: ConsoleUsageWindow;
}

export const Route = createFileRoute("/_authed/_modal/console/usage")({
  validateSearch: (search: Record<string, unknown>): ConsoleUsageSearch => ({
    window: isConsoleUsageWindow(search.window) ? search.window : "30d",
  }),
  loaderDeps: ({ search }) => ({ window: search.window }),
  // Intent preload — fire-and-forget, never blocks navigation. The breakdown
  // (requests/tokens/models) is the primary surface; usage feeds the
  // secondary storage/ingestion panel.
  loader: ({ context: { queryClient }, deps }) => {
    void queryClient.ensureQueryData(consoleUsageBreakdownQueryOptions(deps.window));
    void queryClient.ensureQueryData(consoleUsageQueryOptions(deps.window));
  },
  component: ConsoleUsageRoute,
});

function ConsoleUsageRoute(): React.ReactElement {
  const { window } = Route.useSearch();
  return <ConsoleUsagePage window={window} />;
}
